<template>
  <div :class="cn(variants({ size }), props.class)">
    <slot />
  </div>
</template>

<script setup>
import { sizes, variants } from ".";
import { cn } from "@/Utils/cn";

const props = defineProps({
  size: {
    type: String,
    validator: (val) => sizes.includes(val),
    required: false,
  },
});
</script>
